import { memo, MutableRefObject } from "react";
import {
  InputOnChangeData,
  Grid,
  Input,
  Ref,
  Popup,
  Icon,
} from "semantic-ui-react";

type GatewayIPProps = {
  onChange: (
    event: React.FormEvent<HTMLInputElement>,
    data: InputOnChangeData,
  ) => void;
  zoneId: number;
  gatewayIPRef: MutableRefObject<HTMLElement | null>;
  errorClassName: string;
};

const GatewayIP = ({
  onChange,
  zoneId,
  gatewayIPRef,
  errorClassName,
}: GatewayIPProps) => {
  return (
    <Grid.Row className="padding-top-10">
      <Grid.Column textAlign="left" width={8} className="flex vcenter">
        <h5>
          Gateway IP
          <Popup
            trigger={
              <Icon
                name="warning circle"
                color="grey"
                size="small"
                className="margin-left"
              />
            }
          >
            Optional Gateway IP: Enter a valid IP or leave blank.
          </Popup>
        </h5>
      </Grid.Column>
      <Grid.Column textAlign="left" width={8}>
        <Ref innerRef={gatewayIPRef}>
          <Input
            placeholder={`10.${zoneId}.0.1`}
            className={`select-box full ${errorClassName}`}
            onChange={onChange}
            name="gatewayIp"
          />
        </Ref>
      </Grid.Column>
    </Grid.Row>
  );
};

export default memo(GatewayIP);
